import * as React from "react"

const H2 = ({icon, title, colored}) => (
  <div className={`flex flex-col sm:flex-row items-center text-center justify-center sm:pb-16 text-3xl font-extrabold ${colored ? "text-transparent bg-gradient-to-r bg-clip-text from-skin-pink via-skin-red to-skin-orange" : "text-skin-default"} sm:text-4xl sm:space-x-5 mb-6 sm:mb-0`}>
    {icon}
    <h2 className="pt-6">{title}</h2>
  </div>
)

export default H2